import React from 'react';

const CopyrightFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={footerStyle}>
      <p>© {currentYear} Vigilant. All rights reserved.</p>
    </footer>
  );
};

const footerStyle = {
  textAlign: 'center',
  padding: '1rem',
  backgroundColor: '#f1f1f1',
  color: '#333',
  position: 'fixed',
  left: 0,
  bottom: 0,
  width: '100%',
};

export default CopyrightFooter;
